/* eslint-disable react/prop-types */
import { calendarDataStatusOptions } from '@/constants';
import { cn } from '@/utils/cn';
import { IconTiny } from '@/widgets/components/icon';
import stopTwotone from '@iconify/icons-ant-design/stop-twotone';
import { Tooltip, Whisper } from 'rsuite';
import { writeCalendarBookingAriaLabel } from './calendar-utils';
import { DateCellWrapper } from './details-calendar-styles';

function compactBookingRate(rate) {
  return Intl.NumberFormat('en-US', {
    notation: 'compact',
    maximumFractionDigits: 1,
  }).format(rate);
}

function BookingRate({ bookingRate, isBookingBlocked }) {
  const displayTwCSS = bookingRate ? 'block' : 'hidden';

  if (isBookingBlocked)
    return <IconTiny className={displayTwCSS} icon={stopTwotone} />;

  if (!bookingRate) return null;

  return (
    <div className={cn([displayTwCSS, 'text-xs'])}>{`$${bookingRate}`}</div>
  );
}

export function CustomDateCell({ dateData, colorGetter }) {
  const { rate, isCheckin, status, bookDate, dateNumber } = dateData;

  const bookingRate =
    typeof rate === 'number' && rate > 0 ? compactBookingRate(rate) : '';
  const tooltipText = writeCalendarBookingAriaLabel(status, bookDate, rate);
  const isBookingBlocked = status === calendarDataStatusOptions.BLOCKED;

  return (
    <Whisper
      placement="top"
      speaker={<Tooltip>{tooltipText}</Tooltip>}
      trigger={tooltipText ? ['focus', 'hover'] : null}
    >
      <button
        aria-label={tooltipText}
        className="w-full cursor-default"
        type="button"
      >
        <DateCellWrapper
          aria-hidden
          backgroundColor={colorGetter(dateData, isCheckin)}
          hasRate={Boolean(rate)}
          isBlocked={isBookingBlocked}
        >
          <div className="date-cell-date">{dateNumber}</div>
          <BookingRate
            bookingRate={bookingRate}
            isBookingBlocked={isBookingBlocked}
          />
        </DateCellWrapper>
      </button>
    </Whisper>
  );
}
